import Common from '../common/Common';
import notiLink from './notiLink';
import notiThumbnail from './notiThumbnail';

const com = Common.instance;

function tmpMsg(_obj = {}) {
    const link = notiLink.factory(_obj);
    const iconUrl = notiThumbnail.factory(_obj);
    const iconCls = /noti\/icon/gi.test(iconUrl) ? ' class="icon"' : '';
    const itemNode = document.createElement('li');

    const { isNew, id, msgType, msg, publisher, createMillisec } = _obj;

    if (isNew) {
        itemNode?.classList?.add('on');
    }

    let tmpl = `<div data-notiid="${id}" data-isnew="${isNew}" class="wrapNotice">
        <a ${link}>
            <p class="noticeMsg">${msg}</p>
            <div class="thumb">
                <img ${iconCls} src="${iconUrl}" alt="${publisher?.nickname}">
            </div>
            <time pubdate="pubdate" class="noticeTime">
                ${makeTime(createMillisec)}
            </time>
        </a>
    </div>
    `;

    itemNode.innerHTML = tmpl;
    return itemNode;
}

function tmpLoading(msg = '') {
    return '<div class="loading">Loading...</div>';
}

function tmpNoMsg(msg = '') {
    return '<div class="wrapNoticeBox vAlign-middle wrap_nonedata"><p>' + msg + '</p></div>';
}

function tmpOkFriend(_obj = {}) {
    const { publisher, thumbnailUrl, onErrorUrl } = _obj;
    const { nickname, characterName, serverName } = publisher || {};

    return `<div class="wrapNotice">
        <a>
            <p class="noticeMsg">
                <span class="gnbNtId">
                    <span class="gnbNtNickname">${nickname}</span>
                    <span class="gnbNtCharacter">
                        ${characterName ? `[${characterName}-${serverName}]` : ''}
                    </span>
                </span>님의 친구 신청을 수락했습니다.
            </p>
            <div class="thumb">
                <img src="${thumbnailUrl}" alt="${nickname}" onerror="this.src='${onErrorUrl}'">
            </div>
            <time pubdate="pubdate" class="noticeTime">&#48169;&#44552;&#32;&#51204;</time>
        </a>
    </div>
    <div class="tooltipMsg" style="display:none">친구가 되었습니다.</div>`;
}

function friendAgree_M(_nick) {
    return `<div id="friendAgree_M">
        <section class="modalRelateFriend">
            <div class="wrapCont">
                <dl>
                    <dt>NC친구가 되면?</dt>
                    <dd>서로의 B&S, 아이온 캐릭터를 조회할 수 있습니다.<br />
                        <em>(단, <span class="nickname">닉네임</span>님이 비공개한 캐릭터는 조회 불가)</em>
                    </dd>
                </dl>
                <p class="js_udo"><span class="nickname">
                    ${_nick}</span>님의 <em>NC친구</em> 신청을<br> 수락하시겠습니까?
                </p>
            </div>
        </section>
    </div>`;
}

function friendAgree_I(_nick) {
    return `<div id="friendAgree_I" class="wrapLayer modalAgreeFriend">
        <section class="msgLayer">
            <header><h1>친구 추가</h1></header>
            <section>
                <p>
                    <strong class="username">${_nick}</strong>님의 친구 신청을 수락합니다.
                </p>
                <dl>
                    <dt>친구가 되면?</dt>
                    <dd><em>서로의 아이온 캐릭터</em>를 조회할 수 있습니다.</dd>
                    <dd>리니지/리니지2의 경우 <em>신청/수락한 캐릭터만 조회</em>할 수 있습니다.</dd>
                </dl>
                <menu>
                    <button class="yesAgree">예, 친구 신청을 수락하겠습니다.</button><br>
                    <button class="noAgree js_close">아니오, 친구 신청을 수락하지 않겠습니다.</button>
                </menu>
            </section>
            <div class="button">
                <button class="js_close">닫기</button>
            </div>
        </section>
    </div>`;
}

function alertMessage(msg) {
    return `<div id="notice_alert">
        <section class="modalRelateFriend">
            <div class="wrapCont">
                <p style="border-top: 0; padding: 15px 0 25px 0;">${msg}</p>
            </div>
            <div class="wrapBtns js_udo">
                <button class="js_close" data-dismiss="modal">확인</button>
            </div>
        </section>
    </div>`;
}

let currentTime;

function makeTime(_createMillisec) {
    const createTime = parseInt(_createMillisec);
    const howTime = parseInt((currentTime - createTime) / 1000);
    let timeElm;

    const hasPerS = (str) => str?.includes('%s');
    const l10nNotifications = com.l10nData.Notifications;
    const timeMap = [
        {
            getIsOk: (val) => val < 60,
            getTransform: () => {
                return l10nNotifications['AfewsecondsAgo'];
            }
        },
        {
            getIsOk: (val) => val >= 60 && val < 3600,
            getTransform: (val) => {
                const time = parseInt(val / 60);
                const text = l10nNotifications['MinutesAgo'];
                const isPerS = hasPerS(text);
                return isPerS ? text?.replaceAll('%s', time) : `${time}${text}`;
            }
        },
        {
            getIsOk: (val) => val >= 3600 && val < 86400,
            getTransform: (val) => {
                const time = parseInt(val / (60 * 60));
                const text = l10nNotifications['HhoursAgo'];
                const isPerS = hasPerS(text);
                return isPerS ? text?.replaceAll('%s', time) : `${time}${text}`;
            }
        },
        {
            getIsOk: (val) => val >= 86400 && val < 604800,
            getTransform: (val) => {
                const time = parseInt(val / (60 * 60 * 24));
                const text = l10nNotifications['DaysAgo'];
                const isPerS = hasPerS(text);
                return isPerS ? text?.replaceAll('%s', time) : `${time}${text}`;
            }
        },
        {
            getIsOk: (val) => val >= 604800,
            getTransform: (val) => {
                const date = new Date(createTime);
                return `${date?.getFullYear()}.${date?.getMonth() + 1}.${date?.getDate()}`;
            }
        }
    ];



    timeMap?.some(v => {
        if(!v?.getIsOk(howTime)) {
            return false;
        }

        timeElm = v?.getTransform(howTime);
        return true;
    });

    return timeElm;
}

function setCurrentTime(_t) {
    currentTime = _t;
}

const tmpl = {
    tmpMsg: tmpMsg,
    tmpLoading: tmpLoading,
    tmpNoMsg: tmpNoMsg,
    tmpOkFriend: tmpOkFriend,
    setCurrentTime: setCurrentTime,
    friendAgree_M: friendAgree_M,
    friendAgree_I: friendAgree_I,
    alertMessage: alertMessage,
};

export default tmpl;